enum EVENTS {
    SMART_BANNER_CLOSED = 'smartBannerClosed',
}

export default EVENTS
